
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { lotesXGranja, startListadoLotes, startLoteXID } from "../../../services";






export const useLoteXID = (id) => {
    const loteXIDQuery = useQuery({
        queryKey: ['lote-id', id], 
        queryFn: () => startLoteXID(id),
    });

    return {
        loteXIDQuery
    }
}




export const useLoteXGranja = (id) => {
    const lotesXGranjaQuery = useQuery({
        queryKey: ['lotes-xgranja', id], 
        queryFn: () => lotesXGranja(id),
    });

    return {
        lotesXGranjaQuery,
    }
}




export const useLotesQuery = () => {
    
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');
    const lotesListQuery = useQuery({
        queryKey: ['lotes-list', { page, termino }], 
        queryFn: () => startListadoLotes({ page, termino }),
    });
    
    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        lotesListQuery,
    }
}
